import { getBackendUrl } from '../config';
import { getBotAvatarUrl } from './botAvatar';

/**
 * Monta a URL da foto de perfil do usuário (mesma convenção usada em
 * UsersPresencePanel e no layout). Retorna `null` quando não há imagem —
 * nesse caso use o fallback de iniciais no <Avatar>.
 *
 * O valor guardado no banco costuma ser só o nome do arquivo, mas registros
 * antigos aparecem como path relativo (`public/…`, `company9/user/x.png`) ou
 * já absoluto — daí os casos abaixo.
 */
export const getUserAvatarUrl = (profileImage, companyId) => {
  if (!profileImage || typeof profileImage !== 'string') return null;
  if (/^https?:\/\//i.test(profileImage)) return profileImage;

  const backendUrl = (getBackendUrl() || '').replace(/\/$/, '');
  if (profileImage.startsWith('/')) return `${backendUrl}${profileImage}`;
  if (profileImage.startsWith('public/')) return `${backendUrl}/${profileImage}`;
  if (profileImage.includes('/')) return `${backendUrl}/public/${profileImage}`;
  return `${backendUrl}/public/company${companyId}/profile-images/${profileImage}`;
};

/**
 * Avatar de um remetente do chat interno, cobrindo os três casos numa ordem
 * só (antes ficava duplicado como ternário em ChatMessages e no
 * InternalChatWidget):
 *
 *   1. foto enviada pelo usuário — sempre ganha, inclusive num bot;
 *   2. bot "Sys" do CRM — sentinela `sys-bot`, imagem estática do front;
 *   3. usuário robô (conexão MCP) — robô gerado por hash do id, ver
 *      `botAvatar.js`.
 *
 * Retorna `null` quando não há imagem: aí o <Avatar> cai nas iniciais.
 */
export const getSenderAvatarUrl = (sender) => {
  if (!sender) return null;
  if (sender.profileImage === 'sys-bot') return '/sys-bot.jpeg';
  const uploaded = getUserAvatarUrl(sender.profileImage, sender.companyId);
  if (uploaded) return uploaded;
  if (sender.isBot) return getBotAvatarUrl(sender.id);
  return null;
};

export default getUserAvatarUrl;
